"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDefaultBackgroundCheckProviderDto = instanceOfDefaultBackgroundCheckProviderDto;
exports.DefaultBackgroundCheckProviderDtoFromJSON = DefaultBackgroundCheckProviderDtoFromJSON;
exports.DefaultBackgroundCheckProviderDtoFromJSONTyped = DefaultBackgroundCheckProviderDtoFromJSONTyped;
exports.DefaultBackgroundCheckProviderDtoToJSON = DefaultBackgroundCheckProviderDtoToJSON;
exports.DefaultBackgroundCheckProviderDtoToJSONTyped = DefaultBackgroundCheckProviderDtoToJSONTyped;
const BackgroundCheckProvider_1 = require("./BackgroundCheckProvider");
/**
 * Check if a given object implements the DefaultBackgroundCheckProviderDto interface.
 */
function instanceOfDefaultBackgroundCheckProviderDto(value) {
    if (!('provider' in value) || value['provider'] === undefined)
        return false;
    return true;
}
function DefaultBackgroundCheckProviderDtoFromJSON(json) {
    return DefaultBackgroundCheckProviderDtoFromJSONTyped(json, false);
}
function DefaultBackgroundCheckProviderDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'provider': (0, BackgroundCheckProvider_1.BackgroundCheckProviderFromJSON)(json['provider']),
    };
}
function DefaultBackgroundCheckProviderDtoToJSON(json) {
    return DefaultBackgroundCheckProviderDtoToJSONTyped(json, false);
}
function DefaultBackgroundCheckProviderDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'provider': (0, BackgroundCheckProvider_1.BackgroundCheckProviderToJSON)(value['provider']),
    };
}
//# sourceMappingURL=DefaultBackgroundCheckProviderDto.js.map